import { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import ButtonUtil from "../UI/ButtonUtil";
import SelectBox from "components/web/UI/SelectBox";
import TextFields from "components/web/UI/TextFields";
import { callApi } from "util/HttpService";
import { alert, modalConfirm } from "components/web/cmmn/CmmnConfirm";
import DateRangePickerSingle from "components/web/UI/DateRangePickerSingle";

const ListInputWrap = styled.ul`
    border-top: 2px solid #EF2929;
    min-height: 340px;
    .basic-input {
        padding: 10px;
        font-size: 16px;
        color: #3b3b3b;
        border: 1px solid #D3D3D3;
        border-radius: 4px;
        height: 35px;
    }
    &:focus {
        border-color: #FFA500 !important;
    }
    li:last-child {
        // margin-bottom: 80px;
    }
    .frame-input {
        div {
            width: 50% !important;
            input {
                width: 100% !important;
            }
        }
        select {
            width: 50% !important;
        }
    }
`;
const InputTitle = styled.div`
    height: 54px;
    padding: 15px 20px;
    background-color: #F3F3F3;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    h2 {
        font-size: 16px;
        color: #3b3b3b;
        font-weight: 500;
    }
    &.modal-title {
        margin-bottom: 10px;
        background-color: #fff !important;
        padding: 15px 20px 0px 0px !important;
        h2 {
            font-size: 17px;
            font-weight: 600;
    }
`;
const InputContent = styled.div`
    background-color: #fff;
    padding: 10px 20px 10px 20px;
    & > div {
        // margin-bottom: 10px;
    }
    h3 {
        font-size: 20px;
        color: #3b3b3b;
        font-weight: 500;
        margin-right: 10px;
    }
    h2 {
        font-size: 16px;
        color: #3b3b3b;
        font-weight: 500;
        width: 50%;
    }
    h5 {
        margin-left: 7px;
    }
    input[type="text"]:focus {
        border-color: #FFA500;
    }
`;
const BtnWrap = styled.div`
    width: 100%;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .btn {
        width: 32%;
    }
`;

const DiscountControlWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    width: 100%;
    label {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        margin-right: 4px;
        font-size: 15px;
        color: #3b3b3b;
    }
    .form-select {
        width: calc(50% - 12px);
        min-width: 128px;
    }
`;

const DEFAULT_SYSTEM_SETTINGS = {
    discountPeriodUseYn: 'N',
    discountStartMonthDay: '',
    discountEndMonthDay: '',
    discountTimeUseYn: 'N',
    discountStartTime: '',
    discountEndTime: '',
};
const SYSTEM_MODE_VISIBLE_MAP = {    
    FCC: ["S6", "S7", "S2", "S4", "H1", "H2", "F1", "F3"],
    KSC: ["S6", "S7", "S2", "S4", "H1", "H2", "F1", "F3"],
};

export default function MbSystemConfig({
    t,
    brchClsfCd,
    systemModeArray,
    data,
    kiskInfo,
    onHide,
    getKiskInfo,
}) {
    const [systemSettings, setSystemSettings] = useState({});
    useEffect(() => {
        if (kiskInfo && kiskInfo.sysStupCn) {
            const defaultSettings = (brchClsfCd === 'KSC' || brchClsfCd === 'FCC') ? DEFAULT_SYSTEM_SETTINGS : {};
            setSystemSettings({
                ...defaultSettings,
                ...kiskInfo.sysStupCn,
            });
        }
    }, [kiskInfo, brchClsfCd]);

    // useEffect(() => {
    //     console.log(systemSettings);
    // }, [systemSettings]);

    const handleChange = (e, key) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        setSystemSettings(prevState => ({
            ...prevState,
            [key]: value
        }));
    };

    const handleDiscountPeriodUseChange = (value) => {
        setSystemSettings(prevState => ({
            ...prevState,
            discountPeriodUseYn: value,
            ...(value === 'N'
                ? {
                    discountStartMonthDay: '',
                    discountEndMonthDay: ''
                }
                : {})
        }));
    };

    const handleDiscountTimeUseChange = (value) => {
        setSystemSettings(prevState => ({
            ...prevState,
            discountTimeUseYn: value,
            ...(value === 'N'
                ? {
                    discountStartTime: '',
                    discountEndTime: ''
                }
                : {})
        }));
    };

    // PC 종료 시간
    function generateTimeOptions(minuteStep = 10) {
        const options = [];
        for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += minuteStep) {
                const formattedHour = String(hour).padStart(2, '0');
                const formattedMinute = String(minute).padStart(2, '0');
                options.push({
                    key: `${formattedHour}:${formattedMinute}`,
                    value: `${formattedHour}:${formattedMinute}`,
                });
            }
        }
        return options;
    };
    const pcShutdownTimeArray = generateTimeOptions();
    const discountTimeArray = generateTimeOptions(10);

    function generateMonthDayOptions() {
        const options = [];
        for (let month = 1; month <= 12; month++) {
            const lastDay = new Date(2000, month, 0).getDate();
            for (let day = 1; day <= lastDay; day++) {
                const monthDay = `${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
                options.push({ key: monthDay, value: monthDay });
            }
        }
        return options;
    };

    const discountMonthDayArray = generateMonthDayOptions();
    // 서비스 기본 언어
    const defaultLangArray = [
        { key: "한국어", value: "ko" },
        { key: "日本語", value: "jp" },
        { key: "English", value: "en" },
        { key: "简体中文", value: "cn" },
        { key: "แบบไทย", value: "th" },
        { key: "Tiếng Việt", value: "vi" },
        { key: "melayu", value: "ms" },
        { key: "Español", value: "es" },
        { key: "Français", value: "fr" },
        { key: "bahasa Indonesia", value: "id" },
    ];
    // Iot 보드 포트, 결제기 포트
    const comPortsArray = Array.from({ length: 256 }, (_, i) => ({
        key: `COM${i + 1}`,
        value: `COM${i + 1}`,
    }));
    // 동전투입기 선택
    const coinAcceptorArray = [
        { key: "JY", value: "JY" },
        { key: "VN", value: "VN" },
        { key: "JY-OLD", value: "JY-OLD" },
    ];
    // 프린트 출력 설정
    const printCopiesModeArray = [
        { key: t("systemSetting.optnProdPrintCopiesMode"), value: "prod" },
        { key: t("systemSetting.optnDevPrintCopiesMode"), value: "dev" },
    ];
    // 프린트 드라이버
    const printerDriverArray = [
        { key: "JoySpace", value: "JoySpace" },
        { key: "DnpDsRx1", value: "DnpDsRx1" },
    ];
    // 사진 재촬영 시도 횟수
    const takePhotoRetryCountArray = Array.from({ length: 10 }, (_, i) => ({
        key: (i + 1),
        value: (i + 1)
    }));
    // 지폐수집기 포트
    const billComPortsArray = Array.from({ length: 100 }, (_, i) => ({
        key: `COM${i + 1}`,
        value: `COM${i + 1}`,
    }));
    // 지폐수집기 선택
    const billAcceptorArray = [
        { key: "ict", value: "ict" },
        { key: "oneplus", value: "oneplus" },
    ];
    // 타이틀 화면 컨텐츠
    const titleScreenContentArray = [
        { key: "intro.mp4", value: "intro.mp4" },
        { key: "intro_event.mp4", value: "intro_event.mp4" },
        { key: "intro_dall.mp4", value: "intro_dall.mp4" },
    ];
    // QR 생성 여부
    const qrChkArray = [
        { key: t("systemSetting.optnQrCheckY"), value: "Y"},
        { key: t("systemSetting.optnQrCheckN"), value: "N"},
    ];
    // 배경 적용 여부 배경은 실제 배경을 사용한다는 의미로 적용일경우 키오스 앱의 배경제거 기능을 사용안함을 의미함
    const bgUseArray = [
        { key: t("systemSetting.optnBgUseY"), value: "Y"},
        { key: t("systemSetting.optnBgUseN"), value: "N"},
    ];
    // S3 선택
    const regionArray = [
        { key: "Tokyo", value: "ap-northeast-1"},
        { key: "Sydney", value: "ap-southeast-2"}
    ];

    const handleCmmnBtnClick = async (btnNm) => {
        switch (btnNm) {
            case "cmmnInsertBtn":
                try {
                    const commonParams = { brchId: data.brchId, eqmtId: data.eqmtId, eqmtNo: data.eqmtNo, delYn: 'N' };

                    // systemSettings
                    const systemParams = { ...commonParams, sysStupCn: systemSettings };
                    await callApi("POST", systemParams, "/web/api/dvc-mgt/edm/kisk-insert");
                    console.log("전송된 systemParams : ", systemParams);

                    alert("", t("alert.save"), () => { getKiskInfo() });

                } catch (error) {
                    console.log(error);
                    alert("", t("alert.saveError"), () => { return });
                }
                break;
            case "cmmnResetBtn":
                try {
                    modalConfirm("", t("alert.resetConfirm"), () => {
                        setSystemSettings(kiskInfo.sysStupCn);
                        alert("", t("alert.initSuccessAlert"), () => { });
                    })
                } catch (error) {
                    console.log(error);
                    alert("", t("alert.initFailAlert"), () => { });
                }
                break;
            default: break;
        };
    };

    const handleBirthDayEventDateChange = (e) => {
        const { name, value } = e.target;
        setSystemSettings(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const filteredSystemModeArray = useMemo(() => {
        const visibleValues = SYSTEM_MODE_VISIBLE_MAP[brchClsfCd];
        if (!visibleValues) {
            return systemModeArray;
        }
        return systemModeArray.filter(mode => visibleValues.includes(mode.value));
    }, [brchClsfCd, systemModeArray]);

    return (
        <>
            <ListInputWrap>
                <li>
                    <InputTitle className="modal-title">
                        <h2>1. {t("systemSetting.title")}</h2>
                    </InputTitle>
                    { (brchClsfCd === "KSC" || brchClsfCd === "FCC") && (
                        <>
                            <InputTitle>
                                <h2>{t("systemSetting.lblSystemMode")}</h2>
                            </InputTitle>
                            <InputContent>
                                <SelectBox
                                    defaultOptTxt={t("m_common.selectLable")}
                                    dataArray={filteredSystemModeArray}
                                    onSelectChange={(e) => handleChange(e, 'systemMode')}
                                    tagName="systemMode"
                                    defaultVal={systemSettings?.systemMode || 'S6'}
                                />
                            </InputContent>
                        </>
                    )}
                </li>
                { (brchClsfCd === "KSC" || brchClsfCd === "FCC") &&
                    <li>
                        <InputTitle>
                            <h2>{t("systemSetting.lblCustomModeLabel")}</h2>
                        </InputTitle>
                        <InputContent>
                            <TextFields
                                type="text"
                                name="customModeLabel"
                                onChangeValue={(e) => handleChange(e, 'customModeLabel')}
                                value={systemSettings?.customModeLabel || ""}
                                className="w-100"
                            />
                        </InputContent>
                    </li>
                }

                { (brchClsfCd === "KSC" || brchClsfCd === "FCC") &&(
                    <div className="input-table-wrap">
                        <InputTitle>
                            <h2>{t("systemSetting.lblBirthDayEvent")}</h2>
                        </InputTitle>
                        <InputContent>
                            <DateRangePickerSingle
                                name="birthDayEventRange"
                                startName="birthDayEventStartDate"
                                endName="birthDayEventEndDate"
                                startDate={systemSettings?.birthDayEventStartDate || ''}
                                endDate={systemSettings?.birthDayEventEndDate || ''}
                                onChangeValue={handleBirthDayEventDateChange}
                            />
                        </InputContent>
                    </div>
                )}
                { (brchClsfCd === "KSC" || brchClsfCd === "FCC") &&
                    <li>
                        <InputTitle><h2>{t("systemSetting.lblDiscountPeriod")}</h2></InputTitle>
                        <InputContent>
                            <DiscountControlWrap>
                                <label><input type="radio" name="discountPeriodUseYn" checked={(systemSettings?.discountPeriodUseYn || 'N') === 'Y'} value="Y" onChange={() => handleDiscountPeriodUseChange('Y')} />{t("systemSetting.lblUse")}</label>
                                <label><input type="radio" name="discountPeriodUseYn" checked={(systemSettings?.discountPeriodUseYn || 'N') === 'N'} value="N" onChange={() => handleDiscountPeriodUseChange('N')} />{t("systemSetting.lblNotSet")}</label>
                                <SelectBox defaultOptTxt={t("systemSetting.lblStartDate")} dataArray={discountMonthDayArray} onSelectChange={(e) => handleChange(e, 'discountStartMonthDay')} tagName="discountStartMonthDay" defaultVal={systemSettings?.discountStartMonthDay || ''} disabled={(systemSettings?.discountPeriodUseYn || 'N') === 'N'} />
                                <span>~</span>
                                <SelectBox defaultOptTxt={t("systemSetting.lblEndDate")} dataArray={discountMonthDayArray} onSelectChange={(e) => handleChange(e, 'discountEndMonthDay')} tagName="discountEndMonthDay" defaultVal={systemSettings?.discountEndMonthDay || ''} disabled={(systemSettings?.discountPeriodUseYn || 'N') === 'N'} />
                            </DiscountControlWrap>
                        </InputContent>
                    </li>
                }

                { (brchClsfCd === "KSC" || brchClsfCd === "FCC") &&
                    <li>
                        <InputTitle><h2>{t("systemSetting.lblDiscountTime")}</h2></InputTitle>
                        <InputContent>
                            <DiscountControlWrap>
                                <label><input type="radio" name="discountTimeUseYn" checked={(systemSettings?.discountTimeUseYn || 'N') === 'Y'} value="Y" onChange={() => handleDiscountTimeUseChange('Y')} />{t("systemSetting.lblUse")}</label>
                                <label><input type="radio" name="discountTimeUseYn" checked={(systemSettings?.discountTimeUseYn || 'N') === 'N'} value="N" onChange={() => handleDiscountTimeUseChange('N')} />{t("systemSetting.24hourOperation")}</label>
                                <SelectBox defaultOptTxt={t("systemSetting.lblStartTime")} dataArray={discountTimeArray} onSelectChange={(e) => handleChange(e, 'discountStartTime')} tagName="discountStartTime" defaultVal={systemSettings?.discountStartTime || ''} disabled={(systemSettings?.discountTimeUseYn || 'N') === 'N'} />
                                <span>~</span>
                                <SelectBox defaultOptTxt={t("systemSetting.lblEndTime")} dataArray={discountTimeArray} onSelectChange={(e) => handleChange(e, 'discountEndTime')} tagName="discountEndTime" defaultVal={systemSettings?.discountEndTime || ''} disabled={(systemSettings?.discountTimeUseYn || 'N') === 'N'} />
                            </DiscountControlWrap>
                        </InputContent>
                    </li>
                }


                <li>
                    <InputTitle>
                        <h2>{t("systemSetting.lblPcShutDown")}</h2>
                    </InputTitle>
                    <InputContent>
                        <SelectBox
                            defaultOptTxt={t("systemSetting.24hourOperation")}
                            dataArray={pcShutdownTimeArray}
                            onSelectChange={(e) => handleChange(e, 'pcShutdownTime')}
                            tagName="pcShutdownTime"
                            defaultVal={systemSettings?.pcShutdownTime || ''}
                        />
                    </InputContent>
                </li>
                {brchClsfCd === "KSC" &&
                    <li>
                        <InputTitle>
                            <h2>{t("systemSetting.lblEqmtNo")}</h2>
                        </InputTitle>
                        <InputContent>
                            <TextFields
                                type="text"
                                name="eqmtNo"
                                onChangeValue={(e) => handleChange(e, 'eqmtNo')}
                                value={systemSettings?.eqmtNo || ""}
                                className="w-100"
                            />
                        </InputContent>
                    </li>
                }
                <li>
                    <InputTitle>
                        <h2>{t("systemSetting.lblServiceDefaultLang")}</h2>
                    </InputTitle>
                    <InputContent>
                        <SelectBox
                            defaultOptTxt={t("m_common.selectLable")}
                            dataArray={defaultLangArray}
                            onSelectChange={(e) => handleChange(e, 'defaultLang')}
                            tagName="defaultLang"
                            defaultVal={systemSettings?.defaultLang || 'jp'}
                        />
                    </InputContent>
                </li>
                {brchClsfCd === "KSC" &&
                    <li>
                        <InputTitle>
                            <h2>{t("systemSetting.lblIoTBoardComPort")}</h2>
                        </InputTitle>
                        <InputContent>
                            <SelectBox
                                defaultOptTxt={t("m_common.selectLable")}
                                dataArray={comPortsArray}
                                onSelectChange={(e) => handleChange(e, 'iotComPort')}
                                tagName="iotComPort"
                                defaultVal={systemSettings.iotComPort || 'COM2'}
                            />
                        </InputContent>
                    </li>
                }
                {brchClsfCd === "KSC" &&
                    <li>
                        <InputTitle>
                            <h2>{t("systemSetting.lblCoinAcceptorComPort")}</h2>
                        </InputTitle>
                        <InputContent>
                            <SelectBox
                                defaultOptTxt={t("m_common.selectLable")}
                                dataArray={comPortsArray}
                                onSelectChange={(e) => handleChange(e, 'coinAcceptorComPort')}
                                tagName="coinAcceptorComPort"
                                defaultVal={systemSettings.coinAcceptorComPort || 'COM2'}
                            />
                        </InputContent>
                    </li>
                }
                {brchClsfCd === "KSC" &&
                    <li>
                        <InputTitle>
                            <h2>{t("systemSetting.lblBillAcceptorComPort")}</h2>
                        </InputTitle>
                        <InputContent>
                            <SelectBox
                                defaultOptTxt={t("m_common.selectLable")}
                                dataArray={billComPortsArray}
                                onSelectChange={(e) => handleChange(e, 'billAcceptorComPort')}
                                tagName="billAcceptorComPort"
                                defaultVal={systemSettings.billAcceptorComPort || 'COM1'}
                            />
                        </InputContent>
                    </li>
                }
                {brchClsfCd === "KSC" &&
                    <li>
                        <InputTitle>
                            <h2>{t("systemSetting.lblCoinAcceptorSelect")}</h2>
                        </InputTitle>
                        <InputContent>
                            <SelectBox
                                defaultOptTxt={t("m_common.selectLable")}
                                dataArray={coinAcceptorArray}
                                onSelectChange={(e) => handleChange(e, 'coinAcceptor')}
                                tagName="coinAcceptor"
                                defaultVal={systemSettings.coinAcceptor || 'JY'}
                            />
                        </InputContent>
                    </li>
                }
                {brchClsfCd === "KSC" &&
                    <li>
                        <InputTitle>
                            <h2>{t("systemSetting.lblBillAcceptorSelect")}</h2>
                        </InputTitle>
                        <InputContent>
                            <SelectBox
                                defaultOptTxt={t("m_common.selectLable")}
                                dataArray={billAcceptorArray}
                                onSelectChange={(e) => handleChange(e, 'billAcceptor')}
                                tagName="billAcceptor"
                                defaultVal={systemSettings.billAcceptor || 'oneplus'}
                            />
                        </InputContent>
                    </li>
                }
                <li>
                    <InputTitle>
                        <h2>{t("systemSetting.lblPrintCopiesModeSelect")}</h2>
                    </InputTitle>
                    <InputContent>
                        <SelectBox
                            defaultOptTxt={t("m_common.selectLable")}
                            dataArray={printCopiesModeArray}
                            onSelectChange={(e) => handleChange(e, 'printCopiesMode')}
                            tagName="printCopiesMode"
                            defaultVal={systemSettings.printCopiesMode || 'prod'}
                        />
                    </InputContent>
                </li>
                {brchClsfCd === "KSC" && 
                    <div className="input-table-wrap">
                        <InputTitle>
                            <h2>{t("systemSetting.lblPrinterDriverSelect")}</h2>
                        </InputTitle>
                        <InputContent>
                            <SelectBox
                                defaultOptTxt={t("common.selectLable")}
                                dataArray={printerDriverArray}
                                onSelectChange={(e) => handleChange(e, 'usePrintDriver')}                            
                                tagName="usePrintDriver"
                                defaultVal={systemSettings.usePrintDriver || 'JoySpace'}
                            />
                        </InputContent>
                    </div>
                }
                {brchClsfCd === "KSC" &&
                    <li>
                        <InputTitle>
                            <h2>{t("systemSetting.lblTakePhotoRetryCount")}</h2>
                        </InputTitle>
                        <InputContent>
                            <SelectBox
                                defaultOptTxt={t("m_common.selectLable")}
                                dataArray={takePhotoRetryCountArray}
                                onSelectChange={(e) => handleChange(e, 'takePhotoRetryCount')}
                                tagName="takePhotoRetryCount"
                                defaultVal={systemSettings.takePhotoRetryCount || 5}
                            />
                        </InputContent>
                    </li>
                }
                { (brchClsfCd === "KSC" || brchClsfCd === "FCC") &&
                    <li>
                        <InputTitle>
                            <h2>{t("systemSetting.lblTitleScreenContent")}</h2>
                        </InputTitle>
                        <InputContent>
                            <SelectBox
                                defaultOptTxt={t("m_common.selectLable")}
                                dataArray={titleScreenContentArray}
                                onSelectChange={(e) => handleChange(e, 'titleScreenContent')}
                                tagName="titleScreenContent"
                                defaultVal={systemSettings.titleScreenContent || 'intro.mp4'}
                            />
                        </InputContent>
                    </li>
                }
                {localStorage.getItem("svcKnCd") === "PTMG" ?
                    <li>
                        <InputTitle>
                            <h2>{t("systemSetting.lblQrCheck")}</h2>
                        </InputTitle>
                        <InputContent>
                            <SelectBox
                                defaultOptTxt={t("m_common.selectLable")}
                                dataArray={qrChkArray}
                                onSelectChange={(e) => handleChange(e, 'qrCheckYn')}
                                tagName="qrCheckYn"
                                defaultVal={systemSettings.qrCheckYn || 'Y'}
                            />
                        </InputContent>
                    </li>
                    :<></>
                }
                { (brchClsfCd === "KSC" || brchClsfCd === "FCC") &&
                    <li>
                        <InputTitle>
                            <h2>{t("systemSetting.lblBgUseYn")}</h2>
                        </InputTitle>
                        <InputContent>
                            <SelectBox
                                defaultOptTxt={t("m_common.selectLable")}
                                dataArray={bgUseArray}
                                onSelectChange={(e) => handleChange(e, 'bgUseYn')}
                                tagName="bgUseYn"
                                defaultVal={systemSettings.bgUseYn || 'Y'}
                            />
                        </InputContent>
                    </li>
                }
                {brchClsfCd === "KSC" && 
                    <li>
                        <InputTitle>
                            <h2>{t("systemSetting.lblS3Region")}</h2>
                        </InputTitle>
                        <InputContent>
                            <SelectBox
                                defaultOptTxt={t("m_common.selectLable")}
                                dataArray={regionArray}
                                onSelectChange={(e) => handleChange(e, 's3Region')}
                                tagName="s3Region"
                                defaultVal={systemSettings.s3Region || 'ap-northeast-1'}
                            />
                        </InputContent>
                    </li>
                }
            </ListInputWrap>
            <BtnWrap>
                <ButtonUtil className="btn btn-danger round-filled-small-btn"
                    value={t("common.lblInitBtn")}
                    onClick={() => { handleCmmnBtnClick("cmmnResetBtn") }}
                />
                <ButtonUtil className="btn btn-outline-light round-solid-medium-btn"
                    value={t("common.cancelLable")}
                    onClick={() => { onHide() }}
                />
                <ButtonUtil className="btn btn-danger round-filled-small-btn"
                    value={t("common.saveLable")}
                    onClick={() => { handleCmmnBtnClick("cmmnInsertBtn") }}
                />
            </BtnWrap>
        </>
    )
}
